module.exports = __webpack_public_path__ + "img/202412_skinwash_voice.41f761a9.jpg";